/* eslint-disable import/prefer-default-export */
import setupRequiredIcon from "../../../assets/icons/Setup-Required.svg";
import incompleteIcon from "../../../assets/images/common/spec-flag-icons/IncompleteIcon.svg";
import inProcessIcon from "../../../assets/images/common/spec-flag-icons/InProcessIcon.svg";
import inSpecIcon from "../../../assets/images/common/spec-flag-icons/InSpecIcon.svg";
import outOfSpecIcon from "../../../assets/images/common/spec-flag-icons/OutOfSpecIcon.svg";

export const SPEC_FLAGS_MAP = {
  invalid: {
    label: "-",
    color: "var(--color-content-base)",
    icon: incompleteIcon,
  },
  "-3": {
    label: "Deleted by Lab",
    color: "var(--color-content-negative)",
    icon: outOfSpecIcon,
  },
  "-5": {
    label: "Deleted by User",
    color: "var(--color-content-negative)",
    icon: outOfSpecIcon,
  },
  "-4": {
    label: "Setup Required",
    color: "var(--color-content-warning-text)",
    icon: setupRequiredIcon,
  },
  0: {
    label: "In Process",
    color: "var(--color-content-warning)",
    icon: inProcessIcon,
  },
  1: {
    label: "In Spec",
    color: "var(--color-content-positive)",
    icon: inSpecIcon,
  },
  2: {
    label: "Out of Spec",
    color: "var(--color-content-negative)",
    icon: outOfSpecIcon,
  },
  3: {
    label: "Spec Incomplete",
    altLabel: "View Report",
    color: "var(--color-content-secondary)",
    icon: incompleteIcon,
  },
  4: {
    label: "In Process (Retest)",
    color: "var(--color-content-warning)",
    icon: inProcessIcon,
  },
  5: {
    label: "In Spec (Retest)",
    color: "var(--color-content-positive)",
    icon: inSpecIcon,
  },
  6: {
    label: "Out of Spec (Retest)",
    color: "var(--color-content-negative)",
    icon: outOfSpecIcon,
  },
  7: {
    label: "Out of Trend",
    color: "var(--color-content-negative)",
    icon: outOfSpecIcon,
    description: "Represents an Out of Trend condition.",
  },
  8: {
    label: "Out of Spec",
    color: "var(--color-content-negative)",
    icon: outOfSpecIcon,
    description: "Represents an Out of Spec condition for an in-process sample.",
  },
};

export const SUBMISSION_SPEC_FLAGS_MAP = {
  "-3": {
    display_name: "Deleted",
    color: "var(--color-content-negative)",
  },
  "-2": {
    display_name: "Draft",
    alt_label: "Scheduled",
    color: "var(--color-content-darkblue-primary)",
  },
  "-1": {
    display_name: "Submitted",
    color: "var(--color-content-grey)",
  },
  0: {
    display_name: "Samples Received",
    color: "var(--color-content-blue)",
  },
  1: {
    display_name: "Testing In Progress",
    color: "var(--color-content-yellow)",
  },
  2: {
    display_name: "Testing Completed",
    color: "var(--color-content-green)",
  },
};

//  -5: Deleted by User, -4: Setup Required, -3: Deleted by Lab, -2: Scheduled (Draft), -1: Sampled (Submitted)
export const INVALID_REPORT_SPEC_FLAGS = ["-5", "-4", "-3", "-2", "-1"];

/** Spec flags allowed in sample submission export (CSV), with export-specific labels. */
export const EXPORT_SPEC_FLAG_LABELS = {
  1: "In Spec",
  2: "Out of Spec",
  5: "In Spec-Retest",
  6: "Out of Spec-Retest",
};
